import { createTheme } from '@mui/material/styles';

/**
 * Brand colors. These hexes were already hand-written throughout custom.css and the
 * components (the green appears ~34 times); defining them here once means MUI components
 * inherit the brand instead of every component re-declaring it inline.
 */
const BRAND_GREEN = '#007A03';
const BRAND_GREEN_DARK = '#005502';
const BRAND_GREEN_LIGHT = '#2E9B31';

/**
 * Note: we deliberately do NOT use MUI's CssBaseline here. Bootstrap's reboot is already
 * loaded globally in index.js, and layering a second CSS reset on top of it restyles the
 * entire non-MUI half of the app.
 */
const theme = createTheme({
    palette: {
        primary: {
            main: BRAND_GREEN,
            dark: BRAND_GREEN_DARK,
            light: BRAND_GREEN_LIGHT,
            contrastText: '#ffffff',
        },
        text: {
            primary: '#2c3e50',
            secondary: '#7f8c8d',
        },
    },
    shape: {
        borderRadius: 8,
    },
    typography: {
        // matches the `body, input, select, textarea` rule in custom.css so MUI components
        // stop falling back to Roboto, which the app never loads
        fontFamily: '\'Source Sans Pro\', sans-serif',
        button: {
            textTransform: 'none',
            fontWeight: 600,
        },
    },
    components: {
        MuiDialog: {
            defaultProps: {
                maxWidth: 'sm',
                fullWidth: true,
                closeAfterTransition: true,
            },
            styleOverrides: {
                paper: {
                    borderRadius: 12,
                },
            },
        },
        MuiDialogTitle: {
            styleOverrides: {
                root: {
                    fontWeight: 700,
                },
            },
        },
        MuiDialogActions: {
            styleOverrides: {
                root: {
                    padding: '16px 24px',
                    gap: 8,
                },
            },
        },
        MuiButton: {
            defaultProps: {
                disableElevation: true,
            },
            styleOverrides: {
                root: {
                    paddingLeft: 20,
                    paddingRight: 20,
                },
            },
        },
    },
});

export default theme;